module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (198).e8ee5892.jpg";